import { Breadcrumb } from "../shell/Shell.js";
import { EmptyState } from "../components.js";

/**
 * Honest placeholder for views whose data layer lands in a later milestone (Forecast, Capability,
 * Reliability, Friction, Connectors). Per the design's honest-states principle, this is a calm
 * "not available yet" — never a faked screen. M0 ships Portfolio + the evidence drilldown live.
 */
export function ComingSoon({ title }: { title: string }): React.ReactNode {
  return (
    <>
      <Breadcrumb items={[{ label: "Portfolio", to: "/portfolio" }, { label: title }]} />
      <div className="head">
        <h1>{title}</h1>
      </div>
      <div style={{ marginTop: 24 }}>
        <EmptyState
          message={`${title} arrives in a later milestone. M0 delivers the portfolio and the evidence drilldown over the live API — every figure backed by its source.`}
        />
      </div>
    </>
  );
}
